import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div``;

export const SkipToContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;

export const SkipToOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 0 10px;
  flex: 1;
`;

export const Text = styled(TextLayoutComponent)`
  width: 60px;
  text-align: left;
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    min-width: unset;
    flex: 1
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 40px;
`;

export const DeleteButton = styled(TextLayoutComponent.Error)`
  cursor: pointer;
`;
